module.exports = __webpack_public_path__ + "img/mission-targets-bg.jpg?c664019a752e620c6631fe738bc7326b";